import instance from '@/service/instance';
import {AxiosInstance, AxiosPromise} from 'axios'
import {Exercise} from '@/helpers/types'

const resource: string = '/exercise';

interface UpdateParams {
  id?: number;
  token: string;
  payload: any;
}

export default {
  async list(token: string, params = ''): Promise<any> {
    const { data } = await instance.get(`${resource}${params}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return data;
  },
  async paginatedList(token: string, params = {}): Promise<any> {
    const { data } = await instance.get(`${resource}/paginated-list`, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params,
    });
    return data;
  },
  get(id: number, token: string): AxiosPromise<any> {
    return instance.get(`${resource}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  edit({id, token, payload}: UpdateParams): AxiosPromise<Exercise> {
    return instance.patch(`${resource}/${id}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      },
    });
  },
  create({token, payload}: UpdateParams): AxiosPromise<Exercise> {
    return instance.post(`${resource}/`, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      },
    });
  },
  remove(token: string, id: string): AxiosPromise<void> {
    return instance.delete(`${resource}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      },
    });
  }
};
